import React from 'react';

const Step4 = ({ persona }) => (
  <React.Fragment>
    <div className="col-12 py-110">
      <div className="center mx-auto" style={{ maxWidth: '1010px' }}>
        <p className="title mb-10">
          Thank you!
        </p>

        <p className="mb-20 text-tuna">
          The persona is now ready to be downloaded.
        </p>

        <div className="flex flex-column flex-center">
          <a className="btn btn--primary col-12 mb-20" style={{ maxWidth: '300px' }} href={`/personas/${persona.id}`}>
            View
          </a>

          <a className="btn btn--primary btn--primary--wisp-pink col-12 mb-20" style={{ maxWidth: '300px' }} href={`/personas/${persona.id}/download`}>
            Download PDF
          </a>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Step4
